import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import ModalControl from '../../../Common/Modal/Modal';
import Loader from '@ey/loader';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifButton from '@ey/motif-react-wrapper/Button';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import {labels, moduleType} from '../../../../util/uiconstants';
import env from '../../../../util/env';
import {
	getCountries,
	getSubServiceLines,
	getAdminRoles
} from '../../../../actions/admin/masterDataActions';
import {setIsModalOpen} from '../../../../actions/modalstateactions';
import {clearErrors} from '../../../../actions/erroractions';
import {addRole} from '../../../../actions/admin/manageaccessactions';
import Toast from '../../../Common/Toast/Toast';
import {useLocation} from 'react-router-dom';
import {getLocalizedAPIError, validateTicketNumber} from '../../common/util';
import TicketField from '../../common/ticketfield';

function AssignRole(props) {
	const dispatch = useDispatch();
	const history = useHistory();

	const modules = useSelector((state) => state.modules);
	const roles = useSelector((state) => state.roles);
	const countries = useSelector((state) => state.countries);
	const subServiceLines = useSelector((state) => state.subServiceLines);

	const [selectedModuleId, setselectedModuleId] = useState(null);
	const [selectedRoleId, setSelectedRoleId] = useState('');
	const [selectedSubServiceLineId, setSelectedSubServiceLineId] = useState(
		null
	);
	const [selectedCountryIds, setCountryIds] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isAssignButonEnable, setIsAssignButonEnable] = useState(false);
	const [keyCounter, setKeyCounter] = useState(0);
	const [errorMessage, setErrorMessage] = useState(false);
	const [isErrorOccurred, setIsErrorOccurred] = useState(false);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);

	const onTicketChanged = (e) => {
		setTicketNumber(e.target.value ?? '');
	}

	const type = {
		module: 'modules',
		role: 'roles',
		servicLine: 'servicLine',
		countries: 'countries'
	};
	const location = useLocation();

	useEffect(() => {
		getApiCall();
		clearError(true);
	}, []);

	useEffect(() => {
		if (
			selectedModuleId != moduleType.Engagements &&
			selectedModuleId &&
			selectedRoleId
		) {
			setIsAssignButonEnable(true);
		} else if (
			selectedModuleId == moduleType.Engagements &&
			selectedModuleId &&
			selectedRoleId &&
			selectedSubServiceLineId &&
			selectedCountryIds.length > 0
		) {
			setIsAssignButonEnable(true);
		} else {
			setIsAssignButonEnable(false);
		}
	}, [
		selectedModuleId,
		selectedRoleId,
		selectedSubServiceLineId,
		selectedCountryIds
	]);

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	const getApiCall = () => {
		let URL = env.getURL('serviceUrlV2');

		if (Object.keys(countries).length === 0) {
			dispatch(getCountries(URL + 'countries?pageSize=-1'))
				.then(() => {})
				.catch((e) => {
					setErrorMessage(e.toString());
				});
		}

		if (Object.keys(subServiceLines).length === 0) {
			dispatch(getSubServiceLines(URL + 'ServiceLines'))
				.then(() => {})
				.catch((e) => {
					setErrorMessage(e.toString());
				});
		}

		if (Object.keys(roles).length === 0) {
			dispatch(getAdminRoles(URL + 'SecurityRoles?isAdminRole=true'))
				.then(() => {})
				.catch((e) => {
					setErrorMessage(e.toString());
				});
		}
	};

	const saveRole = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		setIsLoading(true);
		let userId = location.pathname.split('/').at(-1);
		let assignRoleUrl =
			env.getURL('serviceUrlV2') +
			'admin/Users/' +
			userId +
			'/roles/' +
			selectedRoleId;
		var assignRoleScope = {
			subServiceLineId: parseInt(selectedSubServiceLineId),
			countryIds: selectedCountryIds.map((v) => parseInt(v))
		};

		let data = {
			scope: assignRoleScope,
			ticketNumber: ticketNumber
		}

		dispatch(addRole(assignRoleUrl, data))
			.then(() => {
				hideRolesDrawer();
				props.setIsSubmitted(true);
			})
			.catch((error) => {
				setIsErrorOccurred(true);
				setErrorMessage(getLocalizedAPIError(error));
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const hideRolesDrawer = () => {
		setselectedModuleId(null);
		setSelectedRoleId(null);
		setSelectedSubServiceLineId(null);
		setCountryIds([]);
		setIsErrorOccurred(false);
		props.setAssignRoleModalFromChild(false);

		let location = history.location;
		let path = location.pathname + location.search;
		if (location.hash && location.hash.length > 0) {
			history.push(path);
			history.replace({state: {customLabel: props?.customLabel}});
		}
	};

	const getCountriesForDropDown = () => {
		let modulesItems = [];
		if (Object.keys(countries).length > 0) {
			_.forEach(countries, (item) => {
				if (item) {
					modulesItems.push({
						value: item.countryId.toString(),
						label: item.countryName
					});
				}
			});
		}
		return modulesItems;
	};

	const getModulesForDropDown = () => {
		let modulesItems = [];
		if (Object.keys(modules).length > 0) {
			_.forEach(modules, (item) => {
				if (item) {
					modulesItems.push({
						value: item.id.toString(),
						label: item.name
					});
				}
			});
		}
		return modulesItems;
	};

	const getRolesForDropDown = () => {
		let roleItems = [];

		if (Object.keys(roles).length > 0) {
			const filteredRoles = roles?.filter(function (item) {
				return item.moduleId == selectedModuleId;
			});

			_.forEach(filteredRoles, (item) => {
				if (item) {
					roleItems.push({
						value: item.rbacId.toString(),
						label: item.name
					});
				}
			});
		}

		return roleItems;
	};

	const getSubServiceLinesItems = () => {
		let subServiceLinesItems = [];
		if (Object.keys(subServiceLines).length > 0) {
			_.forEach(subServiceLines, (item) => {
				subServiceLinesItems.push({
					label: item.name,
					value: item.id.toString()
				});
			});
		}
		return subServiceLinesItems;
	};

	const formatOptionLabel = ({value, label}) => (
		<EllipsesControl content={label} tooltip={label} noOfLines={1} />
	);

	const createDropDown = (
		collection,
		uniqueName,
		label,
		multiple,
		showselectallbutton,
		key = 0
	) => {
		return (
			<MotifFormField>
				<MotifLabel id="select-label-search" position='in'>{label}</MotifLabel>
				<MotifSelect
					id={uniqueName}
					onChange={(e) => dropDownOnChange(e, uniqueName)}
					filter
					arialabelledby="select-search"
					multiple={multiple}
					showSelectAllButton={
						showselectallbutton ? showselectallbutton : undefined
					}
					value={setDropDownVal(uniqueName)}
				>
					{collection?.map((item) => (
						<MotifOption
							key={item.value}
							value={item.value}
							label={item.label}
						>
							<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
						</MotifOption>
					))}
				</MotifSelect>
			</MotifFormField>
		);
	};

	const setDropDownVal = (actionType) => {
		if (actionType === type.module) {
			return selectedModuleId;
		} else if (actionType === type.role) {
			return selectedRoleId;
		} else if (actionType === type.servicLine) {
			return selectedSubServiceLineId;
		} else if (actionType === type.countries && selectedCountryIds?.length ) {
			return selectedCountryIds;
		} 
		return null;
	}

	const dropDownOnChange = (option, actionType) => {
		switch (actionType) {
			case type.module:
				setKeyCounter(keyCounter + 1);
				setSelectedRoleId(null);
				setSelectedSubServiceLineId(null);
				setCountryIds([]);
				setselectedModuleId(option == '' ? null : option);
				break;
			case type.role:
				setSelectedRoleId(option);
				break;
			case type.servicLine:
				setSelectedSubServiceLineId(option);
				break;
			case type.countries:
				setCountryIds(option?.flat().filter(o => o));
				break;
		}
	};

	return (
		<Mainwrapper>
			<ModalControl
				title={labels.manageAccessAssignRole}
				closeTitle={labels.close}
				closeBtnTitle={labels.cancel}
				modalsize="small"
				show={props.showAssignRoleModal}
				isOkButtonDisabled={false}
				showButtons={false}
				modalContainerClass="assignrolewrapper"
				onHide={() => hideRolesDrawer()}
				focusTrapActive={false}
			>
				{isLoading ? (
					<Loader show fullscreen view="blockView" styleName="loadingstyle" />
				) : (
					<section className="assignrole">
						<section className="assignrolemodal customScrollbar">
							<section className="wrapper">
								<section className="message motif-body1-default-regular">{labels.assignRoleModalMessage}</section>
								<section
									className="toastMessage"
									style={{display: isErrorOccurred ? 'block' : 'none'}}
								>
									<Toast
										variant="error"
										onClose={() => {
											setIsErrorOccurred(false);
											setErrorMessage(false);
										}}
									>
										{errorMessage}
									</Toast>
								</section>
								{createDropDown(
									getModulesForDropDown(),
									type.module,
									labels.selectModule
								)}

								{createDropDown(
									getRolesForDropDown(),
									type.role,
									labels.selectRole,
									false,
									false,
									keyCounter
								)}

								{selectedModuleId == moduleType.Engagements ? (
									<>
										{createDropDown(
											getSubServiceLinesItems(),
											type.servicLine,
											labels.serviceLine
										)}
										{createDropDown(
											getCountriesForDropDown(),
											type.countries,
											labels.countries,
											true,
										)}
									</>
								) : (
									<></>
								)}
							</section>
							<TicketField
								ticketNumber={ticketNumber}
								onTicketChanged={onTicketChanged}
								showValidation={isSubmitClicked}
							/>
						</section>
						<section className="motif-modal-footer">							
							<MotifButton
								variant="ghost"
								onClick={() => hideRolesDrawer()}
								size='medium'
							>
								{labels.cancel}
							</MotifButton>
							<MotifButton
								variant="primary"
								disabled={!isAssignButonEnable || ticketNumber.trim().length <= 0}
								onClick={() => saveRole()}
								size='medium'
							>
								{labels.confirmAssignRoleButton}
							</MotifButton>
						</section>
					</section>
				)}
			</ModalControl>
		</Mainwrapper>
	);
}

const Mainwrapper = styled.section`
	overflow: hidden;

	.wrapper {
		.message {
			padding-bottom: var(--spacing-x-large);
		}
		.motif-form-field {
			width: var(--px-400);
			padding-bottom: var(--spacing-x-large);
		}
	}
	//heading
	.manageaccess {
		.pageheading {
			display: flex;
			padding: var(--px-20) 0;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	//addon

	.add-on {
		display: flex;
		margin-right: auto;
		padding-bottom: var(--spacing-x-large);
		.adduser {
			display: flex;
			align-items: end;
		}

		.search {
			width: var(--px-400);
			margin-right: auto;
		}
	}

	//pagination

	.pagerholder {		
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--spacing-x-large) 0;
	}

	.manageaccess-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}

    .norecord{
        height: calc(100vh - var(--px-316));
        display: inline-block;
        width: 100%;
        display: flex;
        justify-content: center;
        flex: 0 auto;
        align-items: center;
        font-size: var(--px-16);
        color: var(--neutrals-700);
    }

    .managerolesTable {
        height: 100%;
        overflow-y: auto;
        .motif-table {
            height: calc(100vh - var(--px-250));
    
            &.ag-theme-material .ag-checkbox-input-wrapper:focus-within {
                box-shadow: none;
            }
    
            .ag-header-cell {
                color: var(--neutrals-700);
                &:hover,
                    &.ag-header-cell-moving{
                        background: transparent!important;
                    }
            }
    
            .ag-header-cell .ag-header-select-all{
                visibility: hidden;
            }
    
            .ag-body-viewport{
                height: calc(100vh - var(--px-300));
                border: var(--px-1) solid ${(props) =>
									props.theme.color['grey200']} !important;
    
                &:after{
                    content: none;
                }
            }
    
            .ag-header-viewport {
                background: var(--neutrals-100);
                font-size: var(--px-14);
            }
            .ag-root.ag-layout-normal {
                overflow-y: auto;
                width: 100%;
            }
    
            .ag-root.ag-layout-auto-height {
                display: block;
            }
    
            .ag-center-cols-viewport {
                overflow-x: hidden;
            }
    
            .ag-row-hover{
                border-width: 0 0 var(--px-1) 0 !important;		
                border-style: solid !important;
                border-color: ${(props) =>
									props.theme.color[`grey250`]} !important;
            }
    
            .ag-row{
                border-width: 0 0 var(--px-1) 0 !important;		
                border-style: solid !important;
                border-color: ${(props) =>
									props.theme.color[`grey250`]} !important;
                color: var(--neutrals-700);
    
                .ag-cell-value{
                    font-weight: 100;
                }
            }
    
            .ag-row,
            .ag-row-hover {
                background: var(--neutrals-00white) !important;
                font-weight: normal;
    
                .ag-column-hover {
                    background: ${(props) =>
											props.theme.color[`white`]} !important;
                }
            }
    
            .ag-header-row .ag-header-cell{
                &:hover{
                    background: var(--neutrals-100)
                }
            }
    
            .ag-cell,
            .ag-header-cell {
                font-size: var(--px-14);
                padding: 0 var(--px-20);
                display: block;
    
                
                .ag-react-container {
                    [role='button'] {
                        cursor: default;
                    }
                }
    
                .ag-header-cell-text{
                    font-size: var(--px-14);
                }
            }
    
            .ag-header-cell:last-child,
            .ag-cell:last-child {
                border-right: none;
                display: flex;
                text-align:right;
                justify-content: center;
            }
    
            .roleType.disabled,
            .roleType.disabled *{
                color: var(--neutrals-300)!important;
                fill: var(--neutrals-300);
            }
            .noptr{
                pointer-events: none;
            }
            .disabled{
                color: var(--neutrals-300)!important;
                fill: var(--neutrals-300);
            }
    
            .roleType {
                display: inline-block;
                width: 100%;
                align-items: center;
    
                &.enable.icon{
                    fill: var(--neutrals-1000)!important;
                }
                .columnName{
                    font-size: var(--px-13);
                    font-weight: bold;
                    color: var(--neutrals-900);
                    padding-bottom: var(--px-5);
                    }
                }
            }
    
            .errorRow {
                color: var(--red-600) !important;
            }
        }
    
        .ag-body-horizontal-scroll {
            display:none;
        }
    
        .ag-layout-normal {
            &::-webkit-scrollbar {
                width: var(--px-6);
            }
            &::-webkit-scrollbar-track {
                background: var(--neutrals-200);
                width: var(--px-6);
            }
            &::-webkit-scrollbar-thumb {
                background: var(--neutrals-300);
                width: var(--px-6);
                cursor: pointer;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: var(--neutrals-700);
            }
        }
    
`;

export default AssignRole;
